import { render, staticRenderFns } from "./KBLI.vue?vue&type=template&id=39e60c8e&"
import script from "./KBLI.vue?vue&type=script&lang=js&"
export * from "./KBLI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports